import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createAdPlatform,
  listAdPlatforms,
  setAdPlatformStatus,
  updateAdPlatform,
} from './ad-platforms';
import type { CreateAdPlatformReq } from './ad-platforms';
import { adPlatformKeys } from './query-keys';
import type { DictQuery } from './types';

export function useAdPlatformList(query: DictQuery = {}) {
  return useQuery({
    queryKey: adPlatformKeys.list(query),
    queryFn: () => listAdPlatforms(query),
  });
}

export function useCreateAdPlatform() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createAdPlatform,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adPlatformKeys.lists() });
    },
  });
}

export function useUpdateAdPlatform() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ platformId, ...req }: { platformId: number } & CreateAdPlatformReq) =>
      updateAdPlatform(platformId, req),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adPlatformKeys.lists() });
    },
  });
}

export function useSetAdPlatformStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ platformId, status }: { platformId: number; status: 0 | 1 }) =>
      setAdPlatformStatus(platformId, status),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adPlatformKeys.lists() });
    },
  });
}
